import { render, staticRenderFns } from "./updateHouseSort.vue?vue&type=template&id=5a8d9f55&"
import script from "./updateHouseSort.vue?vue&type=script&lang=js&"
export * from "./updateHouseSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports